import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { InquiryRequest } from '../../models/api/client.model';
import { InquiryCreateDto } from '../../models/inquiry-dto.model';

/**
 * Public-facing inquiry submission service.
 * Submits directly to the /Inquiry/client-request endpoint.
 */
@Injectable({ providedIn: 'root' })
export class PublicInquiryService {
  private readonly http = inject(HttpClient);
  private readonly inquiryUrl = `${environment.apiUrl}/Inquiry/client-request`;

  submitInquiry(dto: InquiryCreateDto): Observable<boolean> {
    const fallbackFirst = dto.name ? dto.name.split(' ')[0] : 'Unknown';
    const fallbackLast =
      dto.name && dto.name.split(' ').length > 1 ? dto.name.split(' ').slice(1).join(' ') : '';

    const body: InquiryRequest = {
      firstName: dto.firstName || fallbackFirst,
      lastName: dto.lastName || fallbackLast,
      email: dto.email,
      phone: dto.phone || null,
      productId: dto.productId || 0,
      inquiryType: dto.inquiryType || 'General',
      inquiryTypeId: dto.inquiryTypeId || null,
      message: dto.message,
    };

    return this.http.post<boolean>(this.inquiryUrl, body);
  }
}
